import { get, post } from '../api.service';

export const loginWithEmailAndPassword = async (user: { email: string; password: string }) => {
    const requestBody = { ...user, role: 2 };
    return await post(`/auth/login`, requestBody);
};

export const getEmployeeForMobileAuth = async (userId: string) => {
    return await get(`/employee/get/${userId}`);
};
